import type { EvseStatus } from "../types/ocpi";
import { useI18n } from "../i18n/LanguageContext";
import { BRAND } from "../config/brand";

const COLOR: Record<string, { dot: string; bg: string; text: string }> = {
  AVAILABLE: { dot: BRAND.statusAvailable, bg: "bg-brand-50", text: "text-brand-700" },
  CHARGING: { dot: BRAND.statusCharging, bg: "bg-amber-50", text: "text-amber-700" },
  RESERVED: { dot: BRAND.statusCharging, bg: "bg-amber-50", text: "text-amber-700" },
  OUTOFORDER: { dot: BRAND.statusOutOfOrder, bg: "bg-red-50", text: "text-red-700" },
  INOPERATIVE: { dot: BRAND.statusOutOfOrder, bg: "bg-red-50", text: "text-red-700" },
  BLOCKED: { dot: BRAND.statusOutOfOrder, bg: "bg-red-50", text: "text-red-700" },
  PLANNED: { dot: BRAND.statusUnknown, bg: "bg-ink-50", text: "text-ink-600" },
  REMOVED: { dot: BRAND.statusUnknown, bg: "bg-ink-50", text: "text-ink-600" },
  UNKNOWN: { dot: BRAND.statusUnknown, bg: "bg-ink-50", text: "text-ink-600" },
};

export function StatusPill({ status, size = "sm" }: { status: EvseStatus; size?: "xs" | "sm" }) {
  const { t } = useI18n();
  const c = COLOR[status] ?? COLOR.UNKNOWN;
  const label = t(("status" + status) as never) ?? status;
  return (
    <span
      className={
        "chip " +
        c.bg +
        " " +
        c.text +
        (size === "xs" ? " !text-[10px] !px-2 !py-0.5" : "")
      }
    >
      <span
        className="inline-block h-1.5 w-1.5 rounded-full"
        style={{ background: c.dot }}
        aria-hidden
      />
      {label}
    </span>
  );
}
